import { helpers } from 'vuelidate/lib/validators';

export function mrPhoneValidator(value) {
  if (!value) {
    return true;
  }

  var digits = value.replace(/\D/g, '');
  var length = value[0] == 1 ? 11 : 10;
  
  return !helpers.req(value) || !(digits.length < length);
}

export function mrCardValidator(requiredSize) {
  return function(value) {
    if (!value) {
      return true;
    }

    return value.replace(/\D/g, '').length == requiredSize && mod10Check(value);
  };
}

export function isEmptyObject(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

//- What is mod10Check? Look no further: https://en.wikipedia.org/wiki/Luhn_algorithm
function mod10Check(num) {
  var parts = ('' + num).replace(/\D/g, '').split('').reverse();

  var sum = 0;
  for (var i = 0; i < parts.length; i++) {
    var part = +parts[i];
    if (i % 2) {
      part = (+part) * 2;
      if (part > 9) {
        part = 1 + (part % 10);
      }
    }
    sum += part;
  }

  return sum % 10 === 0;
}